(function (root) {
  var FRAC = { "½": 0.5, "¼": 0.25, "¾": 0.75, "⅛": 0.125, "⅜": 0.375, "⅝": 0.625, "⅞": 0.875 };

  function formatIn(n) {
    var v = Math.round(Number(n) * 1000) / 1000;
    if (!isFinite(v)) return "";
    if (Math.abs(v - Math.round(v)) < 1e-6) return String(Math.round(v));
    return String(v);
  }

  function parseIn(raw) {
    var s = String(raw || "").replace(/["″]/g, "").trim();
    var mixed = s.match(/^(\d+)\s+([½¼¾⅛⅜⅝⅞])$/);
    if (mixed) return Number(mixed[1]) + FRAC[mixed[2]];
    if (FRAC[s] != null) return FRAC[s];
    var parts = s.match(/^(\d+)\s+(\d+)\s*\/\s*(\d+)$/);
    if (parts) return Number(parts[1]) + Number(parts[2]) / Number(parts[3]);
    var frac = s.match(/^(\d+)\s*\/\s*(\d+)$/);
    if (frac) return Number(frac[1]) / Number(frac[2]);
    var num = s.match(/^(\d+(?:\.\d+)?)$/);
    if (num) return Number(num[1]);
    return null;
  }

  function stripHtml(html) {
    return String(html || "")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<[^>]+>/g, " ")
      .replace(/&nbsp;/gi, " ")
      .replace(/&quot;/gi, '"')
      .replace(/&#34;/g, '"')
      .replace(/&amp;/gi, "&")
      .replace(/&#189;/g, "½")
      .replace(/&#188;/g, "¼")
      .replace(/&#190;/g, "¾")
      .replace(/&#8539;/g, "⅛")
      .replace(/&#8540;/g, "⅜")
      .replace(/&#8541;/g, "⅝")
      .replace(/&#8542;/g, "⅞")
      .replace(/[ \t]+\n/g, "\n")
      .replace(/[ \t]{2,}/g, " ")
      .replace(/\n{2,}/g, "\n")
      .trim();
  }

  function fieldAfter(text, label) {
    var escaped = String(label).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var match = String(text || "").match(new RegExp(escaped + "\\s*:\\s*([\\s\\S]*?)(?=\\n\\s*[A-Z][^\\n]{0,60}:|$)", "i"));
    return match ? match[1].replace(/\s+/g, " ").trim() : "";
  }

  function prettyName(raw) {
    var t = String(raw || "")
      .replace(/[_]+/g, " ")
      .replace(/([A-Za-z])(\d)/g, "$1 $2")
      .replace(/(\d)([A-Za-z])/g, "$1 $2")
      .replace(/\s+/g, " ")
      .trim();
    if (!t) return "";
    return t.split(" ").map(function (word, i) {
      var lower = word.toLowerCase();
      if (i > 0 && (lower === "or" || lower === "and" || lower === "of" || lower === "the")) return lower;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(" ");
  }

  function cleanMethod(name) {
    var t = prettyName(name);
    if (!t) return "";
    if (/^laser\b/i.test(t)) return "Laser Engrave";
    if (/^embroider/i.test(t)) return "Embroidery";
    if (/silk-?screen/i.test(t) && !/4[- ]?color|full color/i.test(t)) return "Silk-Screen";
    if (/^deboss/i.test(t)) return "Deboss";
    if (/pad print/i.test(t)) return "Pad Print";
    if (/^4[- ]?color|^full color/i.test(t)) return "4-Color Process";
    return t;
  }

  function methodHint(colors) {
    var t = String(colors || "").replace(/\s+/g, " ").trim();
    if (/\$/.test(t)) t = t.split("$")[0].trim();
    if (!t) return "";
    if (/laser/i.test(t)) return "Engraves to show the inside color.";
    var sentence = t.split(/\.\s/)[0].trim();
    if (sentence.length > 140) sentence = sentence.slice(0, 137) + "…";
    return sentence;
  }

  var NUM = "(\\d+\\s+\\d+\\s*/\\s*\\d+|\\d+\\s*/\\s*\\d+|\\d+\\s*[½¼¾⅛⅜⅝⅞]|\\d+(?:\\.\\d+)?|[½¼¾⅛⅜⅝⅞])";
  var INCH = "(?:\\s*(?:\\\"|″|in\\b))?";

  function parseAreas(raw) {
    var out = [];
    String(raw || "").split(/\s*[•|]\s*/).forEach(function (part) {
      var body = part.trim();
      if (!body) return;
      var method = "";
      var colon = body.match(/^([^:]{2,80}):\s*(.+)$/);
      if (colon && /[A-Za-z]/.test(colon[1]) && !/^\d/.test(colon[1].trim())) {
        method = cleanMethod(colon[1]);
        body = colon[2].trim();
      }
      var wh = body.match(new RegExp(NUM + INCH + "\\s*W\\s*[x×]\\s*" + NUM + INCH + "\\s*H", "i"));
      if (wh) {
        var w = parseIn(wh[1]);
        var h = parseIn(wh[2]);
        if (w > 0 && h > 0) out.push({ method: method, w: w, h: h, label: formatIn(w) + "×" + formatIn(h) + " in" });
        return;
      }
      var dia = body.match(new RegExp(NUM + INCH + "\\s*diameter", "i"));
      if (dia) {
        var d = parseIn(dia[1]);
        if (d > 0) out.push({ method: method, w: d, h: d, diameter: true, label: formatIn(d) + " in diameter" });
      }
    });
    return out;
  }

  function withLabels(areas, fallbackMethod, hint) {
    return (areas || []).map(function (area) {
      return {
        w: area.w,
        h: area.h,
        method: area.method || fallbackMethod || "",
        hint: hint || "",
        label: area.label || (area.w && area.h ? formatIn(area.w) + "×" + formatIn(area.h) + " in" : "")
      };
    });
  }

  function productArtSpecs(copy, promo, opts) {
    opts = opts || {};
    var text = stripHtml(copy);
    var areaText = fieldAfter(text, "Imprint Area And Method");
    var colors = fieldAfter(text, "Imprint Colors");
    var areas = parseAreas(areaText);
    var hint = methodHint(colors);
    var colorMethod = cleanMethod(colors);
    var promoLocs = ((promo && promo.imprint && promo.imprint.locations) || []).filter(function (loc) {
      return loc && (loc.name || loc.id);
    });
    var locations = promoLocs.map(function (loc) {
      var methods = loc.methods || [];
      var picked = methods[0] || {};
      if (/laser/i.test(colors)) {
        methods.forEach(function (method) {
          if (/laser/i.test(method && method.name || "")) picked = method;
        });
      }
      var method = cleanMethod((picked && picked.name) || "") || colorMethod;
      return {
        name: prettyName(loc.name || "Imprint") || "Imprint",
        method: method,
        hint: hint,
        sizes: withLabels(areas.length ? areas : [], method, hint)
      };
    });
    if (!locations.length && (areas.length || opts.promo)) {
      var name = /second side|per side/i.test(text) ? "Side 1" : "Imprint";
      locations = [{
        name: name,
        method: (areas[0] && areas[0].method) || colorMethod,
        hint: hint,
        sizes: withLabels(areas, (areas[0] && areas[0].method) || colorMethod, hint)
      }];
    }
    if (!locations.length) return null;
    var second = /second side/i.test(text);
    if (second && locations.length === 1) {
      var first = locations[0];
      var names = locations.map(function (loc) { return loc.name; });
      if (names.indexOf("Side 2") < 0 && names.indexOf("Second side") < 0) {
        if (first.name === "Imprint" || first.name === "Side") first.name = "Side 1";
        var clone = JSON.parse(JSON.stringify(first));
        clone.name = first.name === "Side 1" ? "Side 2" : "Second side";
        locations.push(clone);
      }
    }
    return { locations: locations };
  }

  function specSentence(specs) {
    var locs = [];
    var size = "";
    var methods = [];
    (specs.locations || []).forEach(function (loc) {
      if (loc.name && locs.indexOf(loc.name) < 0) locs.push(loc.name);
      (loc.sizes || []).forEach(function (row) {
        if (!size && row.label) size = row.label.replace("×", " × ");
        if (row.method && methods.indexOf(row.method) < 0) methods.push(row.method);
      });
      if (loc.method && methods.indexOf(loc.method) < 0 && !(loc.sizes || []).length) methods.push(loc.method);
    });
    var bits = [];
    if (size) bits.push("Imprint area " + size);
    if (locs.length) bits.push(locs.join(" or "));
    if (methods.length === 1) bits.push(methods[0]);
    return bits.length ? bits.join(" · ") + "." : "";
  }

  function bootProductArtSpecs() {
    if (typeof document === "undefined") return;
    document.querySelectorAll("[data-ezink-art-pdp], [data-ezink-line]").forEach(function (node) {
      var copyNode = node.querySelector("[data-ezink-art-copy]");
      var locNode = node.querySelector("[data-ezink-art-promo-locs]");
      var form = node.closest && node.closest("form");
      var promoNode = form && form.querySelector("[data-ezink-promo-json]");
      var copy = "";
      var promo = null;
      if (copyNode) {
        try { copy = JSON.parse(copyNode.textContent || "\"\""); } catch (err) { copy = ""; }
      }
      if (promoNode) {
        try { promo = JSON.parse(promoNode.textContent || ""); } catch (err2) { promo = null; }
      }
      if (locNode && (!promo || !promo.imprint)) {
        try { promo = { imprint: { locations: JSON.parse(locNode.textContent || "[]") } }; } catch (err3) { promo = promo; }
      }
      var promoKind = (node.getAttribute("data-ezink-type") || "") === "Promotional" ||
        /(?:^|,)\s*promo-catalog\s*(?:,|$)/.test(node.getAttribute("data-ezink-tags") || "");
      var specs = productArtSpecs(copy, promo, { promo: promoKind });
      if (!specs) return;
      node.setAttribute("data-ezink-art-specs", JSON.stringify(specs));
      var sentence = specSentence(specs);
      var help = node.querySelector(".ezink-art__help");
      if (help && sentence && !help.querySelector("[data-ezink-art-spec-note]")) {
        var note = document.createElement("span");
        note.setAttribute("data-ezink-art-spec-note", "");
        note.textContent = sentence + " ";
        help.insertBefore(note, help.firstChild);
      }
    });
  }

  var api = { productArtSpecs: productArtSpecs, formatIn: formatIn, specSentence: specSentence };
  root.EZINKArtSpecs = api;
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  if (typeof document !== "undefined") {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bootProductArtSpecs);
    else bootProductArtSpecs();
  }
})(typeof window !== "undefined" ? window : global);
